<template lang="pug">
  .video-view(ref="container")
    v-menu(v-model='openEditDialog' :nudge-width='400' absolute :close-on-content-click="false")
      template(v-slot:activator='{ on, attrs }')
        v-card.elevation-0(v-bind='attrs' v-on='on' :ripple="false")
          v-img(:src="content.value.src")
          div.caption.text-center {{ content.value.caption }}
      v-card
        v-card-title.font-weight-bold.mt-n1 {{ $t('upload_image') }}
        v-card-text.my-n2
          v-file-input(v-model="imageFile" hide-details outlined dense @change="onFileChange" accept="image/*")
        v-card-actions
          v-spacer
          v-btn.mb-2(small text @click.native="openEditDialog = false; imageFile = null") {{ $t('cancel') }}
          v-btn.mb-2.mr-2(small depressed dark color="accent" @click="changeUrl()" :loading="isLoading") {{ $t('upload') }}

</template>

<script>
import { mapActions } from 'vuex'
import { resizeImage } from '@/utils'

export default {
  name: 'ImageView',
  props: ['content'],
  data: () => ({
    openEditDialog: false,
    imageFile: null,
    resizeImageFile: null,
    isLoading: false
  }),
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    async onFileChange () {
      if (!this.imageFile) { return }
      const resizedImage = await resizeImage(this.imageFile, 'page_image_item.jpeg')
      this.resizeImageFile = resizedImage.file
    },
    changeUrl () {
      if (!this.resizeImageFile) {
        this.showMessage(['error', this.$t('error_message.image_invalid')])
        return
      }
      this.isLoading = true
      var params = new FormData()
      params.append('file', this.resizeImageFile)
      this.$axios.post(`/documents/`, params)
        .then(resp => {
          this.content.value.src = resp.data.file
          this.openEditDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_upload_document')])
        })
        .finally(() => {
          this.isLoading = false
        })

    }
  }
}
</script>

<style scoped>
</style>
